import { zIndexes } from 'fitify-ui-onboarding/src/theme/zIndexes'
import { styled } from 'styled-components'

export const StyledContainer = styled.div.attrs<{ $bottomInset: number }>(
  ({ $bottomInset }) => ({
    style: { transform: `translateY(-${$bottomInset}px)` },
  })
)<{ $hasInset: boolean }>`
  position: ${({ $hasInset }) => ($hasInset ? 'absolute' : 'sticky')};
  z-index: ${zIndexes.layoutBottomContent};
  bottom: 0;
  display: flex;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.contentWidth}rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 1rem
    ${({ $hasInset }) =>
      $hasInset ? '1rem' : 'max(1rem, env(safe-area-inset-bottom, 0rem))'};
  gap: 1rem;
  transition: transform 0.3s ease-in-out;
`
